// ============================================================
// GANGING UP, DRAWN (plan design-gaps, Z1; the beats page): threads from the
// actor's allies in reach of the target to it, faint with a "+10?" chip while
// the bonus is only offered, solid with GANG UP once the actor has taken it
// (the attacker's own toggle). Over the figures' feet, under their heads.
// ============================================================

import { memo } from 'react';
import type { Camera } from '../../engine/battlefield/projection';
import { SCENE_VIEW, project } from '../../engine/battlefield/projection';
import type { Token } from '../../engine/battlefield/tokens';
import { headPoint } from '../../engine/display/figures';
import styles from '../../styles/Display.module.css';

export default memo(function GangUpThreads({
  gang,
  tokens,
  targetId,
  pressed,
  camera,
}: {
  gang: { allies: readonly string[] } | null;
  tokens: Readonly<Record<string, Token>>;
  targetId: string | null;
  pressed: boolean;
  camera: Camera;
}) {
  const at = targetId ? tokens[targetId] : undefined;
  if (!gang || !at) return null;
  const to = project(headPoint(at), camera, SCENE_VIEW);
  return (
    <g data-testid="gang-up" data-pressed={pressed || undefined} className={styles.gangUp} pointerEvents="none">
      {gang.allies.map((id) => {
        const from = project(headPoint(tokens[id]), camera, SCENE_VIEW);
        return <line key={id} className={styles.gangThread} x1={from.x} y1={from.y} x2={to.x} y2={to.y} />;
      })}
      <text className={styles.gangChip} x={to.x} y={to.y - 22} textAnchor="middle">
        {pressed ? 'GANG UP' : '+10?'}
      </text>
    </g>
  );
});
